import React from "react";
import CustomComonent from "./CustomComonent";

export default function AgencySales() {
  return (
    <div>
      <CustomComonent />
    </div>
  );
}
